import * as _ from 'lodash';
import { SimpleMapper } from './simple.mapper';
import ISystemEventDTO = ZoningAPI.ISystemEventDTO;
import { ISystemEvent } from '../interfaces/system-event.interface';

export class SystemEventMapper extends SimpleMapper<ISystemEventDTO<any>, ISystemEvent<any>> {
    fromDTOFields = ['Id', 'ParentId', 'ParentType', 'UserId', 'EventType', 'MetaData', 'createdAt'];
}
